import { merge } from 'lodash-es';
import { SwiperOptions } from 'swiper/types';
import { getEnvironment } from './helpers';


export function getSwiperConfig(swiperEl: HTMLElement, defaultOptions: SwiperOptions): SwiperOptions {
  const identifier = swiperEl.id || swiperEl.dataset.id || swiperEl.dataset.name || 'unknown';
  const environment = getEnvironment();
  const dataConfig = swiperEl.dataset.swiper;

  if (!dataConfig) return defaultOptions;

  try {
    const parsed = JSON.parse(dataConfig);
    return merge({}, defaultOptions, parsed);
  } catch {
    if (!environment.isProduction) {
      console.warn(`[pvolve] [${identifier}] data-swiper contains invalid JSON`);
    }

    return defaultOptions;
  }
}
